<template>
<form class="ui form" @submit.prevent="send" :class="{'warning': form.hasErrors()}">
  <app-message :msg="form.appMessage"></app-message>
  <div class="field">
    <div class="ui left icon input">
      <i class="lock icon"></i>
      <input v-model="form.model.new_password" type="password" :placeholder="'パスワード'">
    </div>
    <validation-message :form="form" :field="'new_password'"></validation-message>
  </div>
  <div class="field">
    <div class="ui left icon input">
      <i class="lock icon"></i>
      <input v-model="form.model.password_confirm" type="password" :placeholder="'確認用'">
    </div>
    <validation-message :form="form" :field="'password_confirm'"></validation-message>
  </div>
  <div v-if="!saved" class="field">
    <button type="submit" class="ui fluid orange submit button" :class="{'loading': form.waiting}">保存する</button>
  </div>
  <div v-if="saved" class="ui positive message">
    <div>パスワードが変更されました。<a href="/login">こちら</a>からログインしてください</div>
  </div>
</form>
</template>

<script>
export default {
    data: function() {
        return {
            form: this.createForm(),
            saved: false
        };
    },
    methods: {
        send: function() {
            this.form.put('/api' + window.location.pathname, function() {
                this.saved = true;
            }, function(err) {
                if (err.response.status === 404) {
                    window.location.href = '/reset_password_remind';
                }
            });
        }
    }
};
</script>
